import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";
import { getPermissions } from "store/core";
import getPermissionLabels from "utils/getPermissionLabels";
import Add from "./Add";
import Edit from "./Edit";
import useCanAccess from "hooks/useCanAccess";

export default function Roles() {
  const path = {
    baseRoute: "/role-panel",
    aliasName: "نقش ها",
    type: "Roles",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    create,
    update,
    remove,
    listSearch,
    from,
    to,
    total,
  } = useList();
  const { getPermissions, permissions } = useCore();
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [item, setItem] = useState(false);

  const can = useCanAccess();

  useEffect(() => {
    dispatch(getList(path));
    dispatch(getPermissions());
    return () => {
      dispatch(clear());
    };
  }, []);

  return (
    <>
      <Add
        title="افزودن نقش"
        show={showAdd}
        close={() => {
          setShowAdd(false);
        }}
        submit={(values) => {
          dispatch(
            create(path, values, () => {
              handleSuccessMessages("نقش مورد نظر با موفقیت اضافه شد");
              dispatch(getList(path));
            })
          );
        }}
      />
      <Edit
        item={item}
        title="ویرایش نقش"
        show={showEdit}
        close={() => {
          setShowEdit(false);
        }}
        submit={(values, id) => {
          dispatch(
            update(path, id, values, () => {
              handleSuccessMessages("نقش مورد نظر با موفقیت ویرایش شد");
              dispatch(getList(path));
            })
          );
        }}
      />
      <Delete
        title="حذف نقش"
        show={showDelete}
        close={() => {
          setShowDelete(false);
        }}
        submite={() => {
          dispatch(
            remove(path, list, item?.id, () => {
              handleSuccessMessages("عملیات با موفقیت انجام شد");
              dispatch(getList(path));
              setShowDelete(false);
            })
          );
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">نقش ها</h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            {can("Role", "createOne") && (
              <button
                onClick={() => {
                  setShowAdd(true);
                }}
                className="btn btn-primary shadow-md mr-2"
              >
                افزودن نقش
              </button>
            )}
            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {`نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}
            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">عنوان</th>
                  <th className="whitespace-nowrap text-center">عنوان فارسی</th>
                  <th className="whitespace-nowrap text-center">دسترسی ها</th>
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list.length > 0 && (
                <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((item, index) => (
                    <tr key={`item_${index}`} className="intro-x">
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.name}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.faName}
                        </p>
                      </td>
                      <td className="text-center align-top">
                        <div
                          className="flex flex-col items-center gap-1 overflow-y-auto"
                          style={{
                            maxHeight: "100px",
                            minHeight: "100px",
                            padding: "4px",
                          }}
                        >
                          {getPermissionLabels(item?.permissions, permissions)}
                        </div>
                      </td>

                      <td className="table-report__action w-56">
                        <div className="flex justify-center items-center">
                          {item?.editable ? (
                            <>
                              {can("Role", "updateOne") && (
                                <a
                                  className="flex items-center ml-3 cursor-pointer"
                                  onClick={() => {
                                    setItem(item);
                                    setShowEdit(true);
                                  }}
                                >
                                  {" "}
                                  <Icons.CheckSquare className="w-4 h-4 ml-1" />{" "}
                                  ویرایش{" "}
                                </a>
                              )}
                              {can("Role", "deleteOne") && (
                                <a
                                  className="flex items-center text-theme-6 cursor-pointer"
                                  onClick={() => {
                                    setItem(item);
                                    setShowDelete(true);
                                  }}
                                >
                                  <Icons.Trash2 className="w-4 h-4 ml-1" />
                                  حذف{" "}
                                </a>
                              )}
                            </>
                          ) : (
                            <p className="font-medium whitespace-nowrap text-center">
                              غیر قابل تغییر
                            </p>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
